<template>
  <transition name="modal-fade-zoom">
    <div v-if="clan" class="modal-overlay" @click="closeModal">
      <div class="modal-dialog" @click.stop>
        <div class="modal-content">

          <!-- Header -->
          <div class="modal-header">
            <h5 class="modal-title">
              <span class="me-3">
                <img v-if="isImageSymbol(clan.symbol)" :src="getSymbolUrl(clan.symbol)"
                  :alt="`Símbolo do clã ${clan.name} em Vampiro: A Máscara`" class="clan-symbol-image" loading="lazy">
                <span v-else class="clan-symbol-emoji">{{ clan.symbol }}</span>
              </span>
              {{ clan.name }} - {{ clan.nickname }}
            </h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <!-- Imagem do clã -->
            <div class="clan-image-container">
              <div class="character-image-placeholder">
                <img :src="clan.image" :alt="`Arte do clã ${clan.name} em Vampiro: A Máscara`" class="clan--image-modal"
                  loading="lazy" />
              </div>
              <h6 style="color: var(--vampire-gold); text-align:center; margin-top:10px;">
                {{ clan.nickname }}
              </h6>
            </div>

            <!-- Informações do clã -->
            <div class="clan-info-container">
              <h6 style="color: var(--vampire-gold);">Descrição</h6>
              <p class="mb-4">{{ clan.description }}</p>

              <div class="mb-3">
                <h6 style="color: var(--vampire-gold);">Disciplinas</h6>
                <div class="d-flex flex-wrap">
                  <button v-for="discipline in clan.disciplines" :key="discipline" type="button" class="badge me-2 mb-2"
                    style="background: var(--vampire-red); color: #fff; border: none; cursor: pointer;"
                    @click="openDiscipline(discipline)">
                    <i class="bi bi-bookmark-star me-1"></i>{{ discipline }}
                  </button>
                </div>
              </div>

              <div class="mb-3">
                <h6 style="color: var(--vampire-gold);">Características</h6>
                <p class="mb-2">{{ clan.characteristics }}</p>
              </div>

              <div>
                <h6 style="color: var(--vampire-gold);">Fraqueza do Clã</h6>
                <p class="text-warning">{{ clan.weakness }}</p>
              </div>
            </div>

            <!-- Dicas -->
            <div class="card clan-tips-card mt-4">
              <div class="card-body clan-tips-body">
                <h6 class="card-title" style="color: var(--vampire-gold);">
                  <i class="bi bi-lightbulb me-2"></i>
                  Dicas de Interpretação
                </h6>
                <p class="card-text mb-0">{{ getRoleplayTips(clan.id) }}</p>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-vampire" @click="closeModal">
              <i class="bi bi-x-circle me-2"></i>
              Fechar
            </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ClanModal',
  props: {
    clan: { type: Object, required: true }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    openDiscipline(name) {
      this.$emit('open-discipline', name)
    },
    isImageSymbol(symbol) {
      if (typeof symbol !== 'string') {
        return false
      }

      const normalized = symbol.toLowerCase()
      const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.webp']

      return (
        normalized.startsWith('http://') ||
        normalized.startsWith('https://') ||
        normalized.startsWith('data:') ||
        normalized.startsWith('/') ||
        imageExtensions.some(ext => normalized.includes(ext))
      )
    },
    getSymbolUrl(symbol) {
      if (!symbol || typeof symbol !== 'string') {
        return ''
      }

      if (
        symbol.startsWith('http://') ||
        symbol.startsWith('https://') ||
        symbol.startsWith('data:') ||
        symbol.startsWith('/')
      ) {
        return symbol
      }

      return new URL(`../assets/${symbol}`, import.meta.url).href
    },
    getRoleplayTips(clanId) {
      const tips = {
        brujah: 'Interprete um personagem apaixonado e impulsivo. Questione autoridade, lute por causas justas, mas cuidado com sua fúria. Sua força é sua paixão, mas também sua fraqueza.',
        brujah_anarquista: 'Como um Brujah Anarquista, você é um revolucionário nato. Lute contra o sistema, organize protestos, mas lembre-se que sua causa deve ser maior que você.',
        gangrel: 'Seja selvagem e independente. Prefira a natureza às cidades, confie mais em animais que em vampiros. Sua forma animal reflete sua personalidade.',
        gangrel_anarquista: 'Como Gangrel Anarquista, você valoriza a liberdade acima de tudo. Seja o lobo solitário que protege os oprimidos.',
        malkaviano: 'Sua loucura é única - pode ser paranoia, múltiplas personalidades, ou visões proféticas. Use sua insanidade como força, não fraqueza.',
        nosferatu: 'Aceite sua monstruosidade externa, mas mantenha sua humanidade interna. Seja o espião nas sombras, o informante confiável.',
        toreador: 'Seja obcecado pela beleza e arte. Cultive relacionamentos com mortais artistas. Sua paixão pela vida pode ser sua salvação ou perdição.',
        tremere: 'Valorize conhecimento e hierarquia. Seja ambicioso mas respeitoso com superiores. Sua magia tem preço - sempre.',
        ventrue: 'Lidere com exemplo. Seja nobre, mesmo nas trevas. Sua responsabilidade é com todos os Cainitas, não apenas seu clã.',
        lasombra: 'Abrace as trevas literalmente e figurativamente. Seja orgulhoso, manipulador, mas honre seus compromissos. Liderança através do medo e respeito.',
        tzimisce: 'Seja territorial e tradicionalista. Sua casa é seu castelo. Experimente com Vicissitude, mas lembre-se: você esculpe carne como arte.',
        assamitas: 'Honra e justiça guiam suas ações. Seja o assassino honorável, cumprindo contratos com precisão mortal. Sua palavra é lei.',
        giovanni: 'Família acima de tudo. Negócios são negócios, mas família é sagrada. Use a necromancia com propósito, não por diversão.',
        ravnos: 'Seja o eterno viajante e contador de histórias. Suas ilusões refletem verdades mais profundas. Liberdade é tudo.',
        seguidores_set: 'Corrompa através da tentação, não força. Ofereça o que as pessoas desejam secretamente. Conhecimento proibido é seu domínio.'
      }
      return tips[clanId] || 'Interprete este clã de acordo com suas características únicas e história pessoal.'
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 1050;
  overflow-y: auto;
}

.modal-dialog {
  width: min(100%, 1100px);
}

.modal-content {
  background: linear-gradient(145deg, var(--vampire-dark) 0%, var(--vampire-gray) 100%);
  border: 2px solid var(--vampire-red);
  color: #f8f9fa;
  border-radius: 16px;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
}


.modal-header {
  border-bottom: 1px solid var(--vampire-red);
  padding: 1.5rem 1.75rem;
}

.modal-title {
  color: var(--vampire-gold);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-close {
  filter: invert(1);
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}


.modal-body {
  padding: 2rem;
  display: grid;
  grid-template-columns: minmax(260px, 320px) 1fr;
  gap: 2rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1 1 auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(212, 175, 55, 0.5) transparent;
}

.modal-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.modal-body::-webkit-scrollbar-track {
  background: transparent;
}

.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(212, 175, 55, 0.4);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.modal-body:hover::-webkit-scrollbar-thumb {
  background-color: rgba(212, 175, 55, 0.7);
}

@media (max-width: 768px) {
  .modal-overlay {
    padding: 1rem;
  }

  .modal-body {
    grid-template-columns: 1fr;
    padding: 1.5rem;
  }
}

.clan-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.clan-info-container {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.clan--image-modal {
  width: 100%;
  max-width: 340px;
  max-height: 480px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
}


@media (max-width: 768px) {
  .clan-image-container {
    max-width: 100%;
  }

  .clan--image-modal {
    width: 100%;
    height: auto;
    max-height: none;
  }

  .clan-info-container {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .modal-body {
    padding: 1.25rem;
  }

  .modal-header,
  .modal-footer {
    padding: 1rem 1.25rem;
  }

  .modal-content {
    max-height: 85vh;
  }
}

.clan-symbol-image {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 10px;
}

.clan-symbol-emoji {
  font-size: 2.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}


.modal-footer {
  border-top: 1px solid var(--vampire-red);
  padding: 1.25rem 1.75rem;
  display: flex;
  justify-content: flex-end;
}

.btn-vampire {
  background: var(--vampire-red);
  border: none;
  padding: 0.6rem 1.5rem;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: transform 0.2s ease, background 0.3s ease, box-shadow 0.2s ease;
}

.btn-vampire:hover {
  transform: scale(1.05);
  background: #a30000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.btn-vampire:active {
  transform: scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  background: #8b0000;
}


.character-image-placeholder {
  padding: 0.5rem;
  border: 2px dashed var(--vampire-red);
  border-radius: 8px;
  background: rgba(139, 0, 0, 0.1);
}


.modal-fade-zoom-enter-active,
.modal-fade-zoom-leave-active {
  transition: all 0.3s ease;
}

.modal-fade-zoom-enter-from,
.modal-fade-zoom-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

/* ============================
   DICAS DE INTERPRETAÇÃO - BASE
============================= */
.clan-tips-card {
  grid-column: 1 / -1;
  /* ocupa as duas colunas */
  width: 100%;
  background: var(--vampire-light-gray);
  border: 1px solid var(--vampire-red);
  border-radius: 12px;
  margin-top: 2rem;
  /* respiro em relação ao conteúdo */
}


.clan-tips-body {
  font-size: 1rem;
  line-height: 1.6;
}

/* ============================
   TABLET / MOBILE MÉDIO
============================= */
@media (max-width: 768px) {
  .clan-tips-card {
    margin-top: 1.25rem;
  }

  .clan-tips-body {
    font-size: 0.95rem;
  }
}

/* ============================
   CELULAR (ESTILO APP)
============================= */
@media (max-width: 576px) {
  .clan-tips-card {
    margin-top: 1rem;
    border-radius: 10px;
  }

  .clan-tips-body {
    max-height: 90px;
    overflow-y: auto;
    font-size: 0.9rem;
    padding: 0.75rem 0.9rem;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 8px;
  }

  .clan-tips-body::-webkit-scrollbar {
    width: 4px;
  }

  .clan-tips-body::-webkit-scrollbar-thumb {
    background: rgba(139, 0, 0, 0.4);
    border-radius: 4px;
  }
}
</style>
